import { FC, JSX } from "react";
import { ReactComponent as WarningIcon } from "assets/icons/warning-icon.svg";
import css from "./style.module.css";
import InfoModal from "components/ui/modals/InfoModal/InfoModal";

interface ILoadingRulesModalProps {
  isOpen: boolean;
  variant: string;
  onCancelHandler: () => void;
}

const LoadingRulesModal: FC<ILoadingRulesModalProps> = ({
  isOpen,
  variant,
  onCancelHandler
}): JSX.Element => {
  const isExcel: boolean = variant === "excel";

  const renderTitle = (): JSX.Element => {
    const titleVariant: string = isExcel ? "Excel" : "YML";

    return (
     <div className={css.title}>{`Правила загрузки ${titleVariant}`}</div>
    );
  };

  const renderInfoBlock: JSX.Element = (
   <div>
    <div className="mb-5 text-14-r leading-[18px]">
      По правилам ЭТП, артикул товара должен быть уникальным в рамках каталога одного продавца.
    </div>
    <div className="flex flex-col gap-3 mb-5">
      <div className={css.ruleStyle}>
        При загрузке файла:
      </div>
      {!isExcel ? (
        <>
          <ul className={css.ulInitial}>
            <li>Если артикул уникален — будет создана новая карточка товара.</li>
            <li>Обновить данные по артикулу товара можно следующими способами:</li>
          </ul>
          <ol className={css.olInitial}>
            <li>
              Если выбрать чек-боксы обновления цены и/или свойств товара, то система при совпадении артикулов
              обновит цену и свойства.
            </li>
            <li>
              Если чек-боксы не выбраны, то при совпадении артикулов система обновит все, кроме цены и свойств.
            </li>
          </ol>
          <ul className={css.ulInitial}>
            <li>
              Если Вы хотите полностью обновить каталог, не обращая внимание на артикулы, то при загрузке файла
              выберите чек-бокс &ldquo;Удалить все загруженные товары&ldquo;. Система создаст новые карточки
              товаров из нового файла, удалив все предыдущие товары из каталога.
            </li>
          </ul>
        </>
      ) : (
        <>
          <ul className={css.ulInitial}>
            <li>Если артикул уникален — будет создана новая карточка товара.</li>
            <li>
              При совпадении артикулов данные из файла заменят текущие — это
              может привести к потере ранее внесённой информации.
            </li>
          </ul>
        </>
      )}
    </div>
    <div className="w-full flex items-center justify-between px-3 py-4 gap-2 bg-azure rounded-xl">
      <WarningIcon className="flex-shrink-0" />
      <div className="text-14-r leading-[18px]">
        Рекомендуем перед загрузкой проверить артикулы
        и актуальность данных.
      </div>
    </div>
   </div>
  );

  return (
   <InfoModal
    isOpen={isOpen}
    onClose={onCancelHandler}
    title={renderTitle()}
   >
    {renderInfoBlock}
   </InfoModal>
  );
};

export default LoadingRulesModal;
